import React, { useEffect, useState } from "react";
import { ResponsiveLine } from "@nivo/line";

const WeightChart = ({ patientData, hasWeight}) => {
  const [chartData, setChartData] = useState([]);
  const [yAxisRange, setYAxisRange] = useState({ min: 0, max: 0 });
  const [xTickValues, setxTickValues] = useState([]);
  const [yTickValues, setyTickValues] = useState([]);
  const [yTickValues2, setyTickValues2] = useState([]);

  // Define orange color scheme
  const orangeColor = "#f97316"; // Bright orange
  const fillColor = "rgba(249, 115, 22, 0.2)"; // Solid fill color with 20% opacity

  useEffect(() => {
    if (
      patientData &&
      patientData.month_steps &&
      patientData.month_steps.length >= 7 &&
      hasWeight
    ) {
      const dates = patientData.month_steps[6] || [];
      const weights = patientData.month_steps[5] || []; //CHANGE THIS HERE, need to send data from backend

      // console.log(patientData)
      //Adjust tick interval based on number of points
      const everyNth = (arr, n) => arr.filter((_, i) => i % n === 0)

      const adjustScale = (arr, interval) => {
          let modArray = [...[arr[0] - 2*interval], ...[arr[0] - interval], ...arr, 
            ...[arr[0] + interval], ...[arr[0] + 2*interval]];

          modArray = modArray.map(item => item.toString())

          return modArray;
      };

      const getValueInterval = (value, adjustment) => {
          var interval = 1;

          if(value > 100){
            interval = adjustment;
          }
          else if (value > 50) {
            interval = Math.round(adjustment/2);
          }
          else {
            interval = 1;
          }
          return Number(interval);
      };

      // Create array of data points
      const processedData = dates
        .map((dateStr, index) => {
          const date = new Date(dateStr);
          return {
            date: dateStr,
            formattedDate: date.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            }),
            fullDate: date.toLocaleDateString("en-US", {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
            }),
            weight: weights[index] || null,
          };
        })
        .filter(
          (item) =>
            !isNaN(new Date(item.date).getTime()) &&
            item.weight !== null &&
            item.weight !== 0
        ); // Filter out invalid dates and null/zero weights

      // Sort data by date
      processedData.sort((a, b) => new Date(a.date) - new Date(b.date));

      var interval = 1;
      if(processedData.length > 100){
        interval = 10;
      }
      else if (processedData.length > 50) {
        interval = 5;
      }
      else {
        interval = 1;
      }

      const xTickValues = everyNth(processedData.map(item => item.formattedDate), interval)
      setxTickValues(xTickValues);

      // interval = 1;
      // if(processedData[0].weight > 100){
      //   interval = 5;
      // }
      // else if (processedData[0].weight > 50) {
      //   interval = 2;
      // }
      // else {
      //   interval = 1;
      // }

      interval = getValueInterval(processedData[0].weight, 5);

      // console.log(everyNth(processedData.map(item => item.weight), interval))

      var yTickValues = adjustScale(everyNth(processedData.map(item => item.weight), interval), interval)
      setyTickValues(yTickValues);

      // var lbsScaleData = everyNth(processedData.map(item => item.weight*2.205), interval)
      // console.log(lbsScaleData)

      // interval = getValueInterval((processedData[0].weight*2.205), 10);

      // var yTickValues2 = adjustScale(lbsScaleData, interval)

      // setyTickValues2(yTickValues2);

      // console.log(yTickValues, yTickValues2)

      // Format data for Nivo line chart
      const nivoData = [
        {
          id: "Weight",
          data: processedData.map((item) => ({
            x: item.formattedDate,
            y: item.weight,
            date: item.date,
            fullDate: item.fullDate,
          })),
        },
      ];

      //console.log(nivoData, processedData);

      // Calculate Y-axis range to ensure bottom value isn't on x-axis
      if (processedData.length > 0) {
        const weights = processedData.map((item) => item.weight);
        const minWeight = Math.min(...weights);
        const maxWeight = Math.max(...weights);
        const range = maxWeight - minWeight;

        // Add padding (10% of range) to top and bottom
        const padding = range * 0.2;

        setYAxisRange({
          min: Math.max(0, minWeight - padding), // Ensure we don't go below 0
          max: maxWeight + padding,
        });

        setChartData(nivoData);
      }
      else {

      }

      
    }
  }, [patientData, hasWeight]);

  if (!hasWeight || chartData.length === 0) {
    return null;
  }

  // Simple, clean theme for Nivo
  const theme = {
    background: "transparent",
    textColor: "#333333",
    fontSize: 12,
    axis: {
      domain: {
        line: {
          stroke: "#dddddd",
          strokeWidth: 1,
        },
      },
      ticks: {
        line: {
          stroke: "#dddddd",
          strokeWidth: 1,
        },
        text: {
          fill: "#666666",
          fontSize: 11,
        },
      },
      legend: {
        text: {
          fill: "#666666",
          fontSize: 13,
        },
      },
    },
    grid: {
      line: {
        stroke: "#eeeeee",
        strokeWidth: 1,
      },
    },
    tooltip: {
      container: {
        background: "#ffffff",
        fontSize: 12,
        borderRadius: 3,
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
        padding: "8px 10px",
      },
    },
  };

  // Custom tooltip component matching the step chart format
  const CustomTooltip = ({ point }) => (
    <div
      style={{
        padding: "10px 12px",
        background: "white",
        border: "1px solid #ccc",
        borderRadius: "3px",
        minWidth: "120px",
      }}
    >
      <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
        {point.data.fullDate || point.data.x}
      </div>
      <div style={{ color: orangeColor }}>
        Weight: <strong>{point.data.y.toFixed(1)} kg / {(point.data.y*2.205).toFixed(1)} lbs</strong>
      </div>
    </div>
  );


  return (
    <div className="graph">
      <h3>Fitbit Weight Overview</h3>

      <div style={{ height: "500px", width: "95%"}}>
        <ResponsiveLine
          data={chartData}
          margin={{ top: 40, right: 50, bottom: 50, left: 60 }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: yAxisRange.min,
            max: yAxisRange.max,
          }}
          curve="monotoneX"
          axisTop={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -45,
            legendOffset: 36,
            tickValues: xTickValues,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: " Weight (kg)",
            legendOffset: -50,
            legendPosition: "middle",
            format: (value) => value.toFixed(1),
            tickValues: yTickValues.length,
          }}
          axisRight={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: " Weight (lbs)",
            legendOffset: 50,
            legendPosition: "middle",
            format: (value) => (value*2.2).toFixed(1),
            tickValues: yTickValues.length,
            
          }}
          margin={{ top: 50, right: 70, bottom: 60, left: 70 }}
          colors={[orangeColor]} // Orange color
          pointSize={8}
          pointColor="white"
          pointBorderWidth={2}
          pointBorderColor={orangeColor} // Orange border for points
          enablePointLabel={false}
          pointLabel="y"
          enableGridX={false}
          enableGridY={true}
          enableArea={true}
          areaBaselineValue={yAxisRange.min} // Set baseline to the min value of y-axis
          areaOpacity={0.2} // Solid opacity with no gradient
          useMesh={true}
          theme={theme}
          tooltip={CustomTooltip}
          lineWidth={3} // Slightly thicker line
          // No gradient defs - using solid color instead
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          enableSlices={false}
          legends={[]}
          areaBlendMode="normal" // Normal blend mode for the area
          layers={[
            "grid",
            "markers",
            "areas",
            "crosshair",
            "lines",
            "axes",
            "points",
            "slices",
            "mesh",
            "legends",
          ]}
          // More direct color for the area
          areaColor={fillColor}
        />
      </div>
    </div>
  );
};

export default WeightChart;
